module.exports = __webpack_public_path__ + "assets/laravel.a9528250.svg";